import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.component('page-loader', {
  template: require('./template.html'),
  name: 'page-loader',
  computed: {
    ...mapGetters([
      'editorLoader',
      'globalLoading',
    ]),
  },
  props: ['styles'],
  methods: {
    abortProgress() {
      // reset loading assets
      this.$store.dispatch('setGlobalValue', {
        item: this.editorLoader,
        key: 'progress',
        value: 0,
      });
      this.$store.dispatch('setGlobalValue', {
        item: this.editorLoader,
        key: 'downloading',
        value: false,
      });
      this.$store.dispatch('setGlobalValue', {
        item: this.editorLoader,
        key: 'file',
        value: null,
      });
      this.$store.dispatch('setGlobalValue', {
        item: this.editorLoader,
        key: 'loading',
        value: false,
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/page-loader/index.js